import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: any;
  dataSelected?: {
    id?: string;
    monthYear?: string;
  };
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: null,
  status: ReduxStateType.INIT,
};

const getDetailNotifyIncomeSlice = createSlice({
  name: "getDetailNotifyIncome",
  initialState,
  reducers: {
    getDetailNotifyIncomeStart: (state, _action) => {
      state.dataSelected = {
        id: _action.payload?.id,
        monthYear: _action.payload?.monthYear,
      };
      state.status = ReduxStateType.LOADING;
    },
    getDetailNotifyIncomeSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload?.data ?? null;
    },
    getDetailNotifyIncomeFailed: (state, action) => {
      state.status = action?.payload ?? ReduxStateType.ERROR;
      state.data = null;
    },
    resetDetailNotifyIncome: () => initialState,
  },
});

export const {
  getDetailNotifyIncomeStart,
  getDetailNotifyIncomeSuccess,
  getDetailNotifyIncomeFailed,
  resetDetailNotifyIncome,
} = getDetailNotifyIncomeSlice.actions;

export default getDetailNotifyIncomeSlice.reducer;
